<template>
  <div id="app">
    <div id="loader">

      <div class="showbox">
        <div class="loader">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
          </svg>
        </div>
      </div>

    </div>
    <div id="weebox-notice">
      <i class="icon icon-icon_chat-square-information"></i>
      <span id="weebox-notice-message"></span>
    </div>
    <!--
    <div class="authenticate-status" v-bind:class="{authenticated: $store.getters.isLoggedIn}"></div>
    -->
    <router-view v-if="$store.getters.loaded"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
      return{
          msg: 'Welcome to Your Vue.js App'
      }
  }
}
</script>

<style lang="scss">
  @import './sass/base';
</style>



// WEBPACK FOOTER //
// src/App.vue